import React from 'react';
import { Navigate } from 'react-router-dom';

import { useUser } from '../../contexts/UserContext';
import PrivateLayout from '../layouts/PrivateLayout';
import SalesDashboard from './admin/SalesDashboard';
import useDashboardLook from './admin/useDashboardLook';
import ClientDashboard from './client/ClientDashboard';

// The staff dashboard in the look they picked (Nic 2026-10-24). The classic
// look sits in the normal page with its footer, like before; the new one is
// fluid: the page fits the window and only the board scrolls sideways, so
// the top menu never needs a horizontal scroll (Nic 2026-10-09).
const StaffDashboard = () => {
  const { user } = useUser();
  const [look, setLook] = useDashboardLook(user?.userId);
  return look === 'classic' ? (
    <PrivateLayout>
      <SalesDashboard look={look} onLookChange={setLook} />
    </PrivateLayout>
  ) : (
    <PrivateLayout fluid hideFooter>
      <SalesDashboard look={look} onLookChange={setLook} />
    </PrivateLayout>
  );
};

// The Signups Awaiting Claim button is gone with Signups (Nic 2026-10-09):
// direct website signups are handed out on the Sales board.
const Dashboard = () => {
  const { hasPermission, hasRole } = useUser();

  if (hasRole('client')) {
    return (
      <PrivateLayout background="#F5F7FA">
        <ClientDashboard />
      </PrivateLayout>
    );
  }

  if (hasRole('referral')) {
    return <Navigate to="/invitations" replace />;
  }

  // Board-only people with no claims permissions would just 403 here:
  // their home is the Sales board.
  if (
    hasPermission('onboarding_board:work') &&
    !hasPermission('claims:view_all') &&
    !hasPermission('claims:view_assigned')
  ) {
    return <Navigate to="/operations/onboarding-support" replace />;
  }

  return <StaffDashboard />;
};

export default Dashboard;
